<template>
  <b-form novalidate @submit.prevent="submit" class="ml-auto mr-auto">
    <p class="mb-5">{{ $t('register.description') }}</p>
    <b-row>
      <b-col v-if="showError" class="col-12 col-md-6 mb-3">
        <b-card>
          <p v-if="showError === 'network'" class="text-danger ml-2 pl-1 mb-1 text-center">{{ $t('register.error_network') }}</p>
          <p v-if="showError === 'email'" class="text-danger ml-2 pl-1 mb-1 text-center">{{ $t('register.error_email') }}</p>
        </b-card>
      </b-col>
    </b-row>
    <b-form-group label-for="mail">
      <b-form-input id="mail" :placeholder="$t('register.mail.label')" v-model="mail" type="email" required :state="$v.mail.$dirty ? !$v.mail.$error : null" @blur="$v.mail.$touch"></b-form-input>
    </b-form-group>
    <b-form-group label-for="mail-repeat">
      <b-form-input id="mail-repeat" :placeholder="$t('register.mail_repeat.label')" v-model="mail_repeat" type="email" required :state="$v.mail_repeat.$dirty ? !$v.mail_repeat.$error : null" @blur="$v.mail_repeat.$touch"></b-form-input>
    </b-form-group>
    <b-form-group label-for="pass">
      <b-form-input id="pass" :placeholder="$t('register.pass.label')" v-model="pass" type="password" required :state="$v.pass.$dirty ? !$v.pass.$error : null" @blur="$v.pass.$touch"></b-form-input>
    </b-form-group>
    <b-form-group label-for="pass-repeat">
      <b-form-input id="pass-repeat" :placeholder="$t('register.pass_repeat.label')" v-model="pass_repeat" type="password" required :state="$v.pass_repeat.$dirty ? !$v.pass_repeat.$error : null" @blur="$v.pass_repeat.$touch"></b-form-input>
    </b-form-group>
    <b-form-group label-for="last-name">
      <b-form-input id="last-name" :placeholder="$t('register.lastName.label')" v-model="lastName" type="text" required></b-form-input>
    </b-form-group>
    <b-form-group label-for="privacy">
      <b-form-checkbox id="privacy" v-model="privacy" :state="$v.privacy.$dirty ? !$v.privacy.$error : null" @blur="$v.privacy.$touch">
        {{ $t('register.privacy.label1') }}
        <b-link class="text-primary" :href="datenSchutzLink">
          {{ $t('register.privacy.label2') }}
        </b-link>
        {{ $t('register.privacy.label3') }}
      </b-form-checkbox>
    </b-form-group>
    <b-row>
      <div class="col-12 col-sm-6 mb-2 mb-sm-0">
        <b-link to="/login" class="btn btn-block btn-secondary">{{ $t('register.cancel') }}</b-link>
      </div>
      <div class="col-12 col-sm-6">
        <b-button class="btn-block" type="submit" variant="primary">{{ $t('register.submit') }}</b-button>
      </div>
      <div class="col-12">
        <p class="ml-2 pl-1 mt-1">
          {{ $t('register.login_intro') }}
          <b-link class="text-primary" to="/login">{{ $t('register.login_label') }}</b-link>
        </p>
      </div>
    </b-row>
  </b-form>
</template>

<script>
import { required, email, sameAs } from 'vuelidate/lib/validators'
import config from '../config'

export default {
  name: 'RegisterForm',
  data () {
    return {
      mail: null,
      mail_repeat: null,
      pass: null,
      pass_repeat: null,
      lastName: null,
      showError: false,
      privacy: false,
      datenSchutzLink: config.serverUrl + '/datenschutz'
    }
  },
  methods: {
    async submit () {
      this.$v.$touch()
      if (!this.$v.$error) {
        this.showError = false
        let result
        try {
          result = await this.$api.user.register({ mail: this.mail, pass: this.pass, lastName: this.lastName })
          if (!result) {
            // email address exists
            this.showError = 'email'
          }
        } catch (e) { // network error etc.
          result = false
          this.showError = 'network'
        }

        if (result) {
          await this.$login()
        }

        return result
      }
      return false
    }
  },
  validations: {
    mail: {
      required,
      email,
      sameAs: sameAs('mail_repeat')
    },
    mail_repeat: {
      required,
      email,
      sameAs: sameAs('mail')
    },
    pass: {
      required,
      sameAs: sameAs('pass_repeat')
    },
    pass_repeat: {
      required,
      sameAs: sameAs('pass')
    },
    privacy: {
      checked (value) {
        return value
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  form {
    max-width: 500px;
    font-family: "Roboto Condensed", sans-serif;
  }
</style>
